import { useQuery } from "@tanstack/react-query";
import OrgService from "../services/Org/OrgService";

export const useClientOrgs = () => {
    return useQuery({
        queryKey: ["clientOrgs"],
        queryFn: () => OrgService.getAllClientOrgsDropDown().then(res => res.data),
        staleTime: Infinity,
        cacheTime: Infinity,
        placeholderData: (prevData) => prevData
    });
};